<script setup>
import _ from 'lodash'
import { ref, onMounted, computed, watch, getCurrentInstance } from 'vue'
import { useNotification } from "@kyvg/vue3-notification"
import { useStore } from 'vuex'
import Tooltip from '../Atoms/Tooltip.vue';

const { notify } = useNotification()
const store = useStore()
const instance = getCurrentInstance();

const props = defineProps({
	email: {
		type: String,
		required: true
	}
})

</script>

<template>
	<main>
		<p class="text-sm text-surface-7 mb-3">
			You do not have permission to access this feature.<br>
			Please contact
			<Tooltip wrapperClass="inline [&>*]:inline" :content="email">
				<span class="text-underline text-white">team owner</span>
			</Tooltip>
			to request access.
		</p>
	</main>
</template>

<style scoped></style>